// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInCalendarMonths as fn } from "../differenceInCalendarMonths.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInCalendarMonths = convertToFP(fn, 2);

// Fallback for modularized imports:
export default differenceInCalendarMonths;
